<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="p1h5">
<p class="centerImage"><img alt="images" id="img13" src="images/img13.jpg"/></p>
<p class="caption">Typical army discharge of the Indian wars period. This one is to Corporal Patrick Prendergast, Company A, Second Infantry, at Fort Omaha, Nebraska, 1893. Prendergast’s unit joined the army command at Pine Ridge Agency in 1890 and served against the Sioux Indians, but he was unsuccessful in seeking a pension for that duty. <em class="italic">Editor’s Collection</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IndianWarVeterans_p15.vue?1d66f03e